import { ButtonProps, ModalButton } from '@vtex/admin-ui'
import { useRef, useState } from 'react'
import { FormattedMessage, MessageDescriptor, useIntl } from 'react-intl'
import { messages } from './messages'
import { styles } from './styles'

type Props = {
  holdToSave: boolean
  onClick: () => void
  loading: boolean
}

type buttonProps = {
  label: MessageDescriptor
  variant: ButtonProps['variant']
  className?: string
}

const confirmButton: buttonProps = {
  label: messages.modal.confirm,
  variant: 'primary',
}

const holdAndSaveButton: buttonProps = {
  label: messages.modal.holdToSave,
  variant: 'secondary',
  className: styles.holdAndSaveButton,
}

export function ModalConfirmButton(props: Props) {
  const { onClick, loading, holdToSave } = props

  const clickedRef = useRef(false)

  const [isHeld, setIsHeld] = useState(false)

  const { $t } = useIntl()

  const { label, variant, className }: buttonProps = holdToSave
    ? holdAndSaveButton
    : confirmButton

  const handleClick = () => {
    if (!holdToSave) {
      onClick()
    }
  }

  const handleOnEnd = () => {
    if (isHeld && !clickedRef.current) {
      onClick()
      clickedRef.current = true
    }
  }

  return (
    <ModalButton
      onClick={handleClick}
      variant={variant}
      loading={loading}
      className={className}
      data-held={isHeld}
      onMouseDown={() => setIsHeld(true)}
      onMouseUp={() => setIsHeld(false)}
      onMouseLeave={() => setIsHeld(false)}
      aria-label={$t(label)}
      data-loading={loading}
      onTransitionEnd={handleOnEnd}
    >
      <FormattedMessage {...label} />
    </ModalButton>
  )
}
